import React from 'react';
import PropTypes from 'prop-types';

export default class Heading extends React.Component {
	render() {
		let {children, lvl, ...rest} = this.props;
		lvl = lvl + this.context.player.options.headingBaseLevel - 1;
		const Component = lvl > 6 ? 'div' : `h${lvl}`;
		return (<Component {...rest}>{children}</Component>)
	}
}

Heading.contextTypes = {
  player: PropTypes.object
}


// WEBPACK FOOTER //
// ./lib/components/heading.js